<template>
    <div>
        <v-row
            dense
            no-gutters
            class="popup-header"
            :class="{ 'plot-grid-layout': type === 'plot-grid' }"
        >
            <Favorite
                v-if="hasFavoriteCta && hasPreview"
                :data="data"
                :location="'preview'"
                @close-popup="closePopup"
            />
            <v-btn
                v-if="hasCloseCta"
                class="popup-header-cta"
                icon
                fab
                small
                elevation="2"
                @click.prevent="closePopup"
            >
                <v-icon small>
                    icon-close
                </v-icon>
            </v-btn>
        </v-row>
        <Preview
            v-if="hasPreview"
            :imageUrl="imagePreview"
            :height="heightPreview[type]"
            :width="widthPreview"
            :isInteractive="isPreviewClickable"
            :isPlotDisabled="isPlotDisabled"
            @go-to-plot="goToPlot"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Favorite from '@/components/plotInformation/components/Favorite';
    import Preview from '@/components/plotInformation/components/Preview';

    export default {
        name: 'PlotHeader',
        components: {
            Favorite,
            Preview,
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            screenProperties: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                heightPreview: {
                    'hotspot': 125,
                    'plot': 125,
                    'plot-grid': 320
                },
                widthPreview: '100%',
                disabledAvailabilities: [
                    2,      // Unavailable
                    4,      // Reserved
                    5       // Sold
                ]
            }
        },
        computed: {
            imagePreview() {
                return this.$props.data.preview ? Array.isArray(this.$props.data.preview) ? this.$props.data.preview[0] : this.$props.data.preview : null;
            },
            hasCloseCta() {
                return this.$props.type !== 'plot-grid';
            },
            plotAvailabilityType() {
                let availabilityObj = this.$props.data.details.find(detail => detail.id === 'availability');
                return availabilityObj ? availabilityObj.type : null;
            },
            isPlotDisabled() {
                return this.plotAvailabilityType ? this.disabledAvailabilities.includes(this.plotAvailabilityType) : false;
            },
            hasFavoriteCta() {
                if ('details' in this.$props.data === false)
                    return false;

                switch (this.$props.type) {
                    case 'plot':
                        return !this.isPlotDisabled && (this.$props.screenProperties.isLargeScreen || (!this.$props.screenProperties.isLargeScreen && !this.$props.screenProperties.isLandscape));
                    case 'plot-grid':
                        return !this.isPlotDisabled;
                    default:
                        return false;
                }
            },
            hasPreview() {
                if (!this.imagePreview)
                    return false;
                switch (this.$props.type) {
                    case 'hotspot':
                    case 'plot':
                        return ((this.$props.screenProperties.isSmallScreen 
                        || this.$props.screenProperties.isTinyScreen) 
                        && !this.$props.screenProperties.isLandscape) 
                        || (this.$props.screenProperties.isLargeScreen || this.$props.screenProperties.isMediumScreen);
                    case 'plot-grid':
                        return true;
                    default:
                        return false;
                }
            },
            isPreviewClickable() {
                return this.$props.data.link || this.externalLink ? true : false;
            },
            externalLink() {
                if (!this.$props.data.details) return null;
                const externalLinkDetail = this.$props.data.details.find(detail => detail.id === 'external_link');
                return externalLinkDetail ? externalLinkDetail.value : null;
            }
        },
        mounted() {
            let dialogElement = document.querySelector('.plot-dialog');
            if (dialogElement)
                dialogElement.parentElement.style['overflow-y'] = 'unset';
        },
        methods: {
            closePopup() {
                this.$emit('close-popup');
            },
            goToPlot() {
                if (this.externalLink) {
                    EventBus.$emit('openExternalLink', this.externalLink);
                    return;
                }
                this.$emit('update-widget', this.data);
            }
        }
    }
</script>

<style lang="scss">
    .popup-header {
        position: absolute;
        top: 0;
        width: 100%;
        height: 10em;
        z-index: 3;
        pointer-events: none;
        &-cta {
            width: 32px;
            height: 32px;
            background: #FDFBFB;
            position: absolute;
            top: -1.25em;
            left: -1.25em;
            pointer-events: auto;
        }
    }

    .v-dialog__content {
        .v-dialog {
            .popup-header {
                &-cta {
                    top: -1.25em;
                    left: -1.25em;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/plotInformation/layout/PlotHeader.vue